<template>
  <div>
    <titulo-modulo titulo="Planos/Benefícios" />

    <v-list class="mt-4">
      <template v-for="(pb, i) in planos_beneficios">
        <v-list-item :key="i" :to="{ path: pb.rota }" v-if="pb.rota != ''">
          <v-list-item-avatar>
            <v-icon>{{ pb.icone }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ pb.descricao }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <visualizar-planos-beneficios v-else :pb="pb" :key="pb.id" />

        <v-divider
          :key="pb.descricao"
          v-if="planos_beneficios.length > i + 1"
        ></v-divider>
      </template>
    </v-list>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import VisualizarPlanosBeneficios from "./VisualizarPlanosBeneficios.vue";

export default {
  components: {
    TituloModulo,
    VisualizarPlanosBeneficios,
  },
  computed: {
    ...mapState("planosBeneficios", ["planos_beneficios"]),
  },
  data: () => ({
    dialog: [],
  }),
};
</script>

<style>
</style>